<script setup>
defineProps({ error: Object })
</script>

<template>
  <NuxtLayout>
    <div class="err">
      <p class="err-code">{{ error?.statusCode || 500 }}</p>
      <h1>{{ error?.statusCode === 404 ? '找不到這個頁面' : '系統發生錯誤' }}</h1>
      <p class="err-sub">
        {{
          error?.statusCode === 404
            ? '網址可能已經變更或不存在，回首頁看看其他步道吧。'
            : '請稍後再試，若持續發生請聯絡活動小組。'
        }}
      </p>
      <button class="pill" type="button" @click="clearError({ redirect: '/' })">回首頁</button>
    </div>
  </NuxtLayout>
</template>

<style scoped>
.err {
  padding: 60px 0 40px;
  text-align: center;
}

.err-code {
  margin: 0;
  font-size: 96px;
  font-weight: 900;
  line-height: 1;
  color: var(--site-orange);
}

.err h1 {
  margin: 16px 0 0;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.4;
  color: var(--site-title);
}

.err-sub {
  margin: 8px 0 0;
  font-size: 16px;
  line-height: 1.7;
  color: var(--site-text-sub);
}

.pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 52px;
  margin-top: 28px;
  padding: 0 40px;
  border: 0;
  border-radius: 999px;
  background: var(--site-orange);
  color: #fff;
  font-family: inherit;
  font-size: 18px;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(var(--site-orange-rgb), 0.28);
  transition:
    background-color 0.25s,
    transform 0.25s cubic-bezier(0.22, 0.61, 0.36, 1),
    box-shadow 0.25s;
}

.pill:hover {
  background: var(--site-orange-deep);
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(var(--site-orange-rgb), 0.36);
}

@media (max-width: 700px) {
  .err-code {
    font-size: 64px;
  }

  .err h1 {
    font-size: 22px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .pill:hover {
    transform: none;
  }
}
</style>
